import { Formik } from "formik";
import { isEmpty } from "lodash-es";

import {
  Form,
  SubmitButton,
  Button,
  TextInput,
  ButtonGroup,
} from "lcm-iot-commons";
import { useIntl } from "react-intl";

type Props = {
  onSubmit: $TSFixMeFunction;
  onCancel: $TSFixMeFunction;
  initialValues: {
    email: string;
    password: string;
  };
};

export default function SignInOtpForm({
  onSubmit,
  onCancel,
  initialValues,
}: Readonly<Props>) {
  const intl = useIntl();

  const validateForm = (values: $TSFixMe) => {
    const errors = {};
    if (isEmpty(values.otpCodeToken)) {
      (errors as $TSFixMe).otpCodeToken = intl.formatMessage({
        id: "validation.otp.mandatory",
      });
    }
    return errors;
  };

  const renderForm = (formProps: $TSFixMe) => {
    const { isSubmitting } = formProps;
    return (
      <Form {...formProps}>
        <p>{intl.formatMessage({ id: "signin.otp.description_1" })}</p>
        <p className="mfa-login-no-space">
          {intl.formatMessage({ id: "signin.otp.description_2" })}
        </p>
        <p>{intl.formatMessage({ id: "signin.otp.description_3" })}</p>
        <TextInput
          {...formProps}
          id="otp-code-token"
          name="otpCodeToken"
          placeholder="123456"
          label={intl.formatMessage({ id: "label.otp" })}
          required
          autoFocus
        />
        <ButtonGroup>
          <SubmitButton
            id="otp-form-submit-button"
            text={intl.formatMessage({ id: "button.verify" })}
            fetching={isSubmitting}
            disabled={!formProps.dirty}
          />
          <Button
            id="otp-form-cancel-button"
            text={intl.formatMessage({ id: "button.cancel" })}
            onClick={onCancel}
          />
        </ButtonGroup>
      </Form>
    );
  };

  return (
    <Formik
      id="asset-form"
      onSubmit={onSubmit}
      initialValues={initialValues}
      validate={validateForm}
    >
      {renderForm}
    </Formik>
  );
}
